import { get, post } from 'services/api';

export const getSellerSummary = async () => get('seller/summary');

export const generateSellerReferralCode = async () => post('seller/referral-code', {});
